import objectFitImages from 'object-fit-images';
import SvgDataUri from 'svg-data-uri';
import 'imagesloaded';
import stickybits from 'stickybits';
import Swiper from 'swiper/dist/js/swiper.js';

require('waypoints/lib/jquery.waypoints.min.js');

export default {
  init() {
    window.Swiper = Swiper;
    const $globalRoot = $('.global');
    const common = {
      body: $('body'),
      header: $globalRoot.find('.header'),
      navigation: $globalRoot.find('.header__navigation'),
      headerTray: $globalRoot.find('.header__navigation__tray'),
      objectFitImages: $globalRoot.find('.global__object-fit'),
      share: {
        parent: $globalRoot.find('.share'),
        button: $globalRoot.find('.share__button')
      },
      aside: $globalRoot.find('.global__aside')
    }; // ensure svg-data-uri background images have loaded before inlining into DOM

    $('[svg-data-uri]').imagesLoaded({
      background: true
    }, function () {
      setTimeout(() => {
        new SvgDataUri();
      }, 100);
    });

    if (common.aside.length) {
      $(window).load(function () {
        new window.Waypoint({
          element: common.aside[0],
          handler: function (direction) {
            // if scrolled passed aside
            if (direction === 'down') {
              // make it stick to the viewport
              stickybits(common.aside[0], {
                stickyBitStickyOffset: common.navigation.innerHeight(),
                useStickyClasses: true
              });
            }
          },
          // offset the position using the height of the header/navigation
          offset: common.navigation.innerHeight()
        });
      });
    } // header navigation hide event


    common.headerTray.on('hide.bs.collapse', function () {
      common.body.removeClass('header--open');
      common.body.addClass('header--closed');
    }); // header navigation show event

    common.headerTray.on('show.bs.collapse', function () {
      common.body.removeClass('header--closed');
      common.body.addClass('header--open');
    }); // polyfill object-fit style for older browsers

    if (common.objectFitImages.length) {
      objectFitImages(common.objectFitImages);
    }

    if (common.share.parent.length) {
      common.share.button.on('click', function (e) {
        e.preventDefault();
        $(this).closest(common.share.parent).toggleClass('share--active');
      });
    } // ensure all assets have loaded before repositioning page scroll


    $(window).load(function () {
      // on click of anchor with hash id
      $('a[href*=#]:not([href=#])').click(function () {
        // if the clicked anchor is a page from this domain
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          let target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            // animate to the hash position
            $('html,body').animate({
              scrollTop: target.offset().top - common.navigation.innerHeight() //offsets for fixed header

            }, 200);
            return false;
          }
        }
      }); // Executed on page load with URL containing an anchor tag.

      if ($(location.href.split("#")[1])) {
        let target = $('#' + location.href.split("#")[1]);

        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top - common.navigation.innerHeight() //offset height of header here too.

          }, 200);
          return false;
        }
      } // trigger the social links in the header


      $('.header__navigation__item--follow-us, .header__navigation__item--close-social').on('click', function () {
        $('.header__navigation__menu').toggleClass('show-social');
      }); // sticky header

      $(window).scroll(function () {
        if ($(this).scrollTop() > 132) {
          $('.header').addClass('header--sticky');
          $('.page-title__header-search-button__container').fadeIn();
        } else {
          $('.header').removeClass('header--sticky');
          $('.page-title__header-search-button__container').fadeOut();
        }
      }); //mobile accordion

      $('.mobile__accordion__chevron').on('click', function () {
        var parent = $(this).parent('.mobile__accordion');
        parent.toggleClass('mobile__accordion--active');
        var target = parent.next('.mobile__accordion__target');
        target.slideToggle('slow');
      }); //banner sliders

      new Swiper('.banner__swiper', {
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        }
      }); //featured jobs swiper

      new Swiper('.featured-jobs__mobile-swiper', {
        loop: true,
        centeredSlides: true,
        spaceBetween: 50,
        pagination: {
          el: '.featured-jobs__mobile-swiper__pagination',
          clickable: true
        }
      }); //featured listiign swiper

      $('.featured-listing__mobile-swiper').each(function (index, element) {
        var swiperId = $(element).data('swiperId');
        new Swiper('.featured-listing__mobile-swiper--' + swiperId, {
          loop: true,
          centeredSlides: true,
          spaceBetween: 50,
          pagination: {
            el: '.featured-listing__mobile-swiper__pagination--' + swiperId,
            clickable: true
          }
        });
      }); // change the footer background color if it is after the reverse banner

      if ($('.banner--reverse').length) {
        $('.footer__container').css('clip-path', 'none');
      } // show the name of the file after the file is selected


      $('.form__file__container').each(function (index, element) {
        var $thisElement = $(element);
        var $fileButton = $('.form__file__button', $thisElement);
        var fileLabel = $fileButton.text();
        $('.form__file', $thisElement).on('change', function () {
          var filename = $(this).val().split('\\').pop();

          if (filename) {
            $fileButton.text(filename);
          } else {
            $fileButton.text(fileLabel);
          }
        });
      });
    });
    /**
     * check if a element is in viewport or not
    */

    function isElementInViewport(el) {
      //special bonus for those using jQuery
      if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
      }

      var rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      /*or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      /*or $(window).width() */
      ;
    } // add the animation class to the element when it is in viewport


    $(window).on('DOMContentLoaded load resize scroll', function () {
      $('.js-animation').each(function (index, element) {
        if (!$(element).hasClass('animation')) {
          var visible = isElementInViewport(element);

          if (visible) {
            $(element).addClass('animation');
          }
        }
      });
    });
  }

};


// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js